import React from "react";
import { Route, Switch } from "react-router-dom";
import { Path } from "paths";
import {
  MdmList, DeviceGeoLocation
} from "modules";
import { useMount } from "hooks";
import { setPageTitle } from "services";

const TransactionPage = () => {
  useMount(() => {
    setPageTitle("mdm");
  });
  
  return (
    <Switch>
      <Route exact path={Path.MDM} component={MdmList} />
      <Route exact path={Path.DEVICE_GEO_LOCATION} component={DeviceGeoLocation} />
    </Switch>
  );
};

export default TransactionPage;
